var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.auditLoading,
          expression: "auditLoading",
        },
      ],
    },
    [
      _c("header", { staticClass: "yxtbiz-trainPlanAudit_title" }, [
        _vm._v(_vm._s(_vm.$t("pc_biz_o2o_change_points" /* 改动点 */))),
      ]),
      _c(
        "yxt-table",
        {
          staticClass: "mt24 width-percent-100",
          attrs: { data: _vm.tableData },
        },
        [
          _c("yxt-table-column", {
            attrs: {
              prop: "title",
              "show-overflow-tooltip": "",
              label: _vm.$t("pc_biz_o2o_content" /* 内容 */),
              width: "180",
            },
          }),
          _vm._l(_vm.columnList, function (ref) {
            var label = ref.label
            var prop = ref.prop
            return _c("yxt-table-column", {
              key: prop,
              attrs: { "show-overflow-tooltip": "", label: label },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.type == 1 && row[prop] != "--"
                          ? _vm._l(row[prop], function (attach, index) {
                              return _c(
                                "div",
                                { key: index },
                                [
                                  _c("yxtbiz-attachment-check", {
                                    attrs: {
                                      data: attach,
                                      mode: "text",
                                      "need-download": true,
                                      "need-delete": false,
                                    },
                                    on: { download: _vm.downfile },
                                  }),
                                ],
                                1
                              )
                            })
                          : row.type == 2 && row[prop] != "--"
                          ? _c("yxt-image", {
                              staticClass: "yxtbiz-trainPlanAudit_imageClass",
                              attrs: {
                                src: row[prop],
                                "preview-src-list": [row[prop]],
                              },
                            })
                          : _c("span", [_vm._v(_vm._s(row[prop]))]),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
        ],
        2
      ),
      _c(
        "yxt-button",
        {
          staticClass: "mt24",
          attrs: { type: "text" },
          on: { click: _vm.viewDetail },
        },
        [
          _vm._v(
            _vm._s(
              _vm.$t("pc_biz_o2o_view_full_plandetail" /* 查看完整计划详情 */)
            )
          ),
        ]
      ),
      _c("PlanDetail", { ref: "plandetailDialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }